import ScreenOption from "./screen-option";
import CreateButton from "./create-button";
import { initAcServices } from "AC/helpers/admin-columns";
var AcServices = initAcServices();
var AddNewInline = /** @class */ (function () {
    function AddNewInline(actions) {
        this.loading = false;
        this.createButton = new CreateButton(actions);
        this.screenOption = null;
        var screenOptionsElement = document.getElementById('acp_new_inline_show_button-1');
        if (screenOptionsElement) {
            this.screenOption = new ScreenOption(screenOptionsElement);
        }
        this.initEvents();
    }
    AddNewInline.prototype.initEvents = function () {
        var _this = this;
        if (this.screenOption && !this.screenOption.isEnabled()) {
            this.createButton.disable();
        }
        if (this.screenOption) {
            this.screenOption.events.addListener('changeState', function (state) {
                state ? _this.createButton.enable() : _this.createButton.disable();
            });
        }
        this.createButton.events.addListener('click', function () {
            _this.addNew();
        });
    };
    AddNewInline.prototype.addNew = function () {
        var _this = this;
        if (this.loading) {
            return;
        }
        this.loading = true;
        this.createButton.toggleLoading(true);
        jQuery.post(window.location.href, {
            ac_action: 'acp_add_new_inline',
            _ajax_nonce: AC.ajax_nonce,
            list_screen: AC.list_screen,
            layout: AC.layout
        }).done(function (response) {
            if (response) {
                if (response.success && response.data.hasOwnProperty('row')) {
                    var $row = jQuery(response.data.row);
                    jQuery('table.wp-list-table tbody').prepend($row);
                    // Small animation to draw attention to new row
                    $row.hide();
                    $row.fadeIn();
                    AcServices.getService('Table').updateRow($row[0]);
                    if (AcServices.hasService('Editing') && AcServices.getService('Editing').hasService('InlineEdit')) {
                        AcServices.getService('Editing').getService('InlineEdit').initRow(response.data.id);
                    }
                }
            }
        }).always(function () {
            _this.loading = false;
            _this.createButton.toggleLoading(false);
        });
    };
    return AddNewInline;
}());
export default AddNewInline;
